var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGenderFemale = function SvgGenderFemale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17.3499C2.25 9.06568 8.96573 2.34995 17.25 2.34995H18.75C27.0343 2.34995 33.75 9.06567 33.75 17.3499V31.15C33.75 33.6352 31.7353 35.6499 29.25 35.6499H6.75C4.26472 35.6499 2.25 33.6352 2.25 31.1499V17.3499Z",
    stroke: "#FF8C69",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31.1499H21C24.3137 31.1499 27 28.4637 27 25.1499V18.0249C27 17.9421 26.9328 17.8749 26.85 17.8749L22.5 17.875C20.0147 17.875 18 15.8603 18 13.375V9.24995C18 9.1671 17.9328 9.09995 17.85 9.09995H13.5C11.0147 9.09995 9 11.1147 9 13.5999V25.1499C9 28.4637 11.6863 31.1499 15 31.1499Z",
    stroke: "#FF8C69",
    strokeWidth: 3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenderFemale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gender_female.422259fa.svg";
export { ForwardRef as ReactComponent };